import { Box, Flex } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";
import { Modal, Row, Col } from "antd";
import { useLoading } from "components/GlobalLoading";
import useParametrosPortaria from "core/features/portaria/hooks/useParametrosPortaria";
import { TipoAutorizacaoPortariaParametroItem } from "core/features/portaria/typings";
import OutlineButton from "ui/components/Button/OutlineButton";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import Toolbar from "ui/components/Toolbar";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import useSalvarParametrosPortaria from "core/features/portaria/hooks/useSalvarParametrosPortaria";
import InputMoney from "components/Input/InputMoney";
import Field from "ui/components/Input/Field";
import { showSuccess } from "infra/helpers/alerta";

interface ModalParametrosPortariaProps {
  visible: boolean;
  onClose: () => any;
}

function ModalParametrosPortaria({
  visible,
  onClose,
}: ModalParametrosPortariaProps) {
  const { control, watch, reset, handleSubmit } = useForm<{
    items: TipoAutorizacaoPortariaParametroItem[];
  }>({
    defaultValues: {
      items: [],
    },
    mode: "all",
  });

  const { data: parametrosPortaria, isLoading } = useParametrosPortaria();
  const { mutate: salvarParametros, isLoading: isLoadingSave } =
    useSalvarParametrosPortaria();

  const onSubmit = (form: {
    items: TipoAutorizacaoPortariaParametroItem[];
  }) => {
    salvarParametros(form, {
      onSuccess: () => {
        showSuccess("Parâmetros salvos com sucesso").then(() => onClose());
      },
    });
  };

  const form = watch();

  useEffect(() => {
    if (parametrosPortaria) {
      reset({
        items: parametrosPortaria,
      });
    }
  }, [reset, parametrosPortaria]);

  useLoading(isLoadingSave || isLoading);
  return (
    <Modal
      destroyOnClose
      width={"380px"}
      closable={false}
      className="antd-custom-header"
      title={
        <Toolbar
          title="Parâmetros de portaria"
          onClose={onClose}
          border="0px"
        />
      }
      centered
      footer={
        <Flex gridGap={4} justifyContent="flex-end">
          <OutlineButton onClick={onClose}>Fechar</OutlineButton>

          <PrimaryButton
            onClick={() => {
              handleSubmit(onSubmit)();
            }}
          >
            Salvar
          </PrimaryButton>
        </Flex>
      }
      visible={visible}
      onCancel={onClose}
    >
      <Flex flexDir="column" gap={3}>
        <Box mb={3}>
          <Text fontWeight="bold">Limite de dias por tipo de autorização</Text>
        </Box>

        <Box as={Row} gutter={16}>
          <Box as={Col} xs={16}>
            <Text fontWeight="medium">Tipo de autorização</Text>
          </Box>
          <Box as={Col} xs={8}>
            <Text fontWeight="medium" textAlign="center">
              Limite de dias
            </Text>
          </Box>
        </Box>

        {form.items.map((item, index) => (
          <Box
            as={Row}
            display="flex"
            alignItems="center"
            gutter={16}
            key={item.id}
          >
            <Box as={Col} xs={16}>
              <Text>{item.nome}</Text>
            </Box>
            <Box as={Col} xs={8}>
              <Field
                control={control}
                name={`items.${index}.limiteDias`}
                render={({ field }) => (
                  <InputMoney
                    value={field.value}
                    onChange={field.onChange}
                    placeholder="0"
                    decimalScale={0}
                    decimalsLimit={0}
                    step={1}
                  />
                )}
              />
            </Box>
          </Box>
        ))}
      </Flex>
    </Modal>
  );
}

export default ModalParametrosPortaria;
